import React from 'react'
import { Avatar } from '@chakra-ui/react'
import { Text, HStack } from '@chakra-ui/react'
import { Tooltip, type TooltipProps } from '@chakra-ui/react'

import SharedStack from '../wrappers/shared-stack'
import { ClientFieldsFragment } from '~graphql/generated/graphql'
import InfoItem, { InfoText } from '../info-item'
import { formatEmail, getClientFullName } from '~utils/helpers'
import { formatPhoneReadable } from '~utils/phone'
import { useClinic } from '~contexts/clinic-context'

interface Props extends TooltipProps {
    client?: Pick<
        ClientFieldsFragment,
        'id' | 'first_name' | 'last_name' | 'email' | 'phone' | 'address'
    > | null
}

export default function ClientInfoTooltip({ client, ...props }: Props) {
    const { clinic } = useClinic()
    const clientName = getClientFullName(client)

    return (
        <Tooltip
            {...props}
            openDelay={300}
            isDisabled={!client}
            placement="start-start"
            bg="white"
            borderWidth={1}
            borderColor="gray.200"
            rounded="lg"
            color="gray.900"
            px={4}
            py={3}
            label={
                <SharedStack>
                    <HStack>
                        <Avatar src={''} name={clientName || ''} size="xs" />
                        <Text fontWeight="semibold">{clientName}</Text>
                    </HStack>
                    <InfoItem
                        label="Email"
                        info={<InfoText>{formatEmail(client?.email)}</InfoText>}
                    />
                    <InfoItem
                        label="Phone"
                        info={
                            <InfoText>
                                {formatPhoneReadable(
                                    client?.phone,
                                    client?.address?.country ||
                                        clinic?.address?.country,
                                )}
                            </InfoText>
                        }
                    />
                </SharedStack>
            }
        />
    )
}
